import axios from '@axios'

export const state = {
  title: [],
  saleDoc: [],
  pickupSlip: [],
  shippingDoc: [],
  acution: [],
  warehouse: [],
  towing: [],
  medias: [],
}

export const getters = {
  allTitle: (state) => state.title,
  allSaleDoc: (state) => state.saleDoc,
  allPickupSlip: (state) => state.pickupSlip,
  allShippingDoc: (state) => state.shippingDoc,
  allAcution: (state) => state.acution,
  allWarehouse: (state) => state.warehouse,
  allTowing: (state) => state.towing,
  allLoading: (state) => state.unloading,
  allMedias: (state) => state.medias,
}

export const mutations = {
  RESET_ALL_MEDEAS: (state) => {
    state.title = []
    state.saleDoc = []
    state.pickupSlip = []
    state.shippingDoc = []
    state.acution = []
    state.warehouse = []
    state.towing = []
    state.medias = []
  },
  GET_MEDIEAS: (state, resp) => {
    if (!resp) return null
    state.medias = resp.medias
  },
  DELETE_MEDIEA: (state, resp) => {
    if (!resp) return null
    state.medias = state.medias.filter((media) => media.id !== resp.id)
  },
  UPLOAD_MEDIEAS: (state, resp) => {
    if (!resp || !resp.medias) return
    state.medias = [...(state.medias || []), ...resp.medias]
  },
}

export const actions = {
  async getMedias({ commit }, params) {
    commit('RESET_ALL_MEDEAS')
    await axios
      .get(`/api/medias`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          let data = Object.assign({}, resp.data)
          commit('GET_MEDIEAS', data)
        }
      })
      .catch(() => {
        commit('GET_MEDIEAS', null)
      })
  },
  async getMediasSync({ commit }, params) {
    return axios.get(`/api/medias`, { params: params })
  },
  async getMediasImage({ commit }, params) {
    return axios.get(`/api/medias-images`, { params: params })
  },
  async uploadMedias({ commit, dispatch, rootState }, data) {
    let form = new FormData()
    let notification = {
      id: Date.now(),
      message: 'Files are uploading',
      type: 'info',
    }
    dispatch('notification/addNotification', notification, {
      root: true,
    })

    for (let field in data) {
      if (field === 'files') {
        // Ensure files is iterable, even if it's null or undefined
        const files = data[field] || []
        for (let file of files) {
          form.append('files', file, file.name)
        }
        continue
      }
      form.append(field, data[field])
    }

    try {
      const resp = await axios.post(`/api/medias`, form)
      if (resp.status === 201) {
        commit('UPLOAD_MEDIEAS', resp.data)
        notification = {
          id: Date.now(),
          message: 'Files are uploaded.',
          type: 'info',
        }

        dispatch('notification/addNotification', notification, {
          root: true,
        })

        return resp.data
      }
    } catch (error) {
      commit('UPLOAD_MEDIEAS', null)
      throw error
    }
  },
  async deleteMedia({ commit }, file) {
    await axios
      .delete(`/api/medias/${file.id}`)
      .then((resp) => {
        if (resp.status === 204) {
          commit('DELETE_MEDIEA', file)
          commit('invoice/DELETE_INVOICE', file, { root: true })
        }
      })
      .catch(() => {
        commit('DELETE_MEDIEA', null)
      })
  },
  async deleteMediaSync({ commit }, file) {
    return axios.delete(`/api/medias/${file.id}`)
  },
}
